<template>
  <div class="leavePage" v-if="!showLoad">
    <van-cell-group class="baseNone baseSalary">
      <van-field
        :value="
          leaveInput.applicantIdName
            ? leaveInput.applicantIdName
            : leaveInput.applicantName
        "
        v-if="mode != 'add'"
        :required="editType"
        readonly
        label="申请人："
        class="ggInput"
      />
      <van-field
        v-model="userinfo.realName"
        v-else
        :required="editType"
        readonly
        label="申请人："
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        label="请假类型："
        :required="editType"
        readonly
        v-model="leaveInput.leaveTypeName"
        @click="showLeavePicker"
        :is-link="editType"
        :placeholder="editType ? '请选择' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText" v-if="holidayType">
      <van-field
        v-model="leaveDay"
        readonly
        :required="editType"
        label="已申请假期天数:"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText" v-if="holidayType">
      <van-field
        v-model="surplusLeaveDays"
        readonly
        :required="editType"
        label="剩余假期天数:"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        label="请假开始时间："
        v-model="leaveInput.startTime"
        :required="editType"
        readonly
        @click="TimePicker(1)"
        :is-link="editType"
        :placeholder="editType ? '请选择' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText" :class="endTimeDisabled?'endTimeDisabled':''">
      <van-field
        label="请假结束时间："
        :required="editType"
        readonly
        v-model="leaveInput.endTime"
        @click="TimePicker(2)"
        :is-link="editType"
        :placeholder="editType&& !endTimeDisabled ? '请选择' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText" v-if="leaveInput.leaveType=='qingjia009'">
      <van-field
        label="哺乳假类别："
        :required="editType"
        readonly
        v-model="leaveInput.lactationTypeName"
        @click="showLactaPicker"
        :is-link="editType"
        :placeholder="editType ? '请选择' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <div class="leaveDats">
      <ul>
        <li>
          <van-cell-group class="baseNone baseSalary moreLeaveText">
            <van-field
              type="number"
              :required="editType"
              v-model="leaveInput.leaveDays"
              label="请假天数（天）："
              :placeholder="editType ? '请输入...  ' : ''"
              readonly
              @input="getCheckLeave"
              class="ggInput"
            />
          </van-cell-group>
        </li>
      </ul>
    </div>
    <van-cell-group class="baseNone beizhu">
      <van-field
        v-model="leaveInput.reason"
        rows="1"
        autosize
        :required="editType"
        label="请假原因："
        type="textarea"
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
      />
    </van-cell-group>
    <!-- 附件 -->
    <!-- 微信的附件 避免和原生交互 -->
    <wx-file-view
      v-if="is_weixn"
      :filesData="leaveInput"
      :editType="editType"
      class="fileview"
    ></wx-file-view>
    <!-- 原生附件 -->
    <file-view
      v-else
      :filesData="leaveInput"
      :editType="editType"
      @changeFile="changebaseAnnexes"
      class="fileview"
    ></file-view>
    <p v-if="leaveInput.leaveType=='qingjia003'" style="color:#999;font-size: 12px;padding: 12px;background-color: #fff;">备注：请上传县、区级以上医院出具相关的证明材料，如医疗诊断书、就诊病历等，连续病假额外提供病休通知书</p>
    <p v-if="leaveInput.leaveType=='qingjia007'" style="color:#999;font-size: 12px;padding: 12px;background-color: #fff;">备注：请上传县、区级以上医院出具的相关证明材料，如产检病历、产检报告、医疗诊断书等</p> 
    <!-- 审批流程 -->
    <div
      class="approveList"
      v-if="mode !== 'add' && leaveInput.verifyStatus != 'hold'"
    >
      <audit-list :applicantData="leaveInput"></audit-list>
    </div>

    <!-- 流程图 -->
    <div
      class="flowList"
      v-if="mode !== 'add' && leaveInput.verifyStatus != 'hold'"
    >
      <flow-staff :applicantData="leaveInput"></flow-staff>
      <flow-list :workflowCode="leaveInput.workflowCode"></flow-list>
    </div>
    <!-- 审批 -->
    <van-popup
      v-model="verifyPageType"
      closeable
      round
      close-icon="close"
      position="bottom"
      class="verifyPage"
    >
      <verify-main
        :applicantData="leaveInput"
        @changeVerifyType="setVerifyType"
      ></verify-main>
    </van-popup>
    <!-- 保存按钮 -->

    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput('add')"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="leaveInput.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput('edit')"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="leaveInput.verifyStatus == 'deny' && mode != 'verify'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput('edit')"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        leaveInput.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          leaveInput.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          leaveInput.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">审批</van-button>
    </div>
    <!-- 弹框 -->
    <!-- 请假类型选择器 -->
    <van-popup v-model="showLeaveTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="leaveTypeList"
        value-key="dictName"
        @cancel="showLeaveTypePicker = false"
        @confirm="saveLeaveType"
      />
    </van-popup>
    <!-- 哺乳假类型选择器 -->
    <van-popup v-model="showLactationPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="lactationList"
        value-key="dictName"
        @cancel="showLactationPicker = false"
        @confirm="savelactationType"
      />
    </van-popup>
    <!-- 时间控件 -->
    <van-popup v-model="showTimePickerOne" position="bottom">
      <van-datetime-picker
        type="datetime"
        :filter="filterOne"
        @cancel="showTimePickerOne = false"
        @confirm="onTimeConfirmOne"
        @change="timeChange"
        :min-date="minDate"
      />
    </van-popup>
    <van-popup v-model="showTimePickerTwo" position="bottom">
      <van-datetime-picker
        type="datetime"
        :filter="filterTwo"
        @cancel="showTimePickerTwo = false"
        @confirm="onTimeConfirmTwo"
        :min-date="minDate"
      />
    </van-popup>

    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/* eslint-disable */
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
const refreshPage = () => import("@/components/common/refreshPage");
const fileView = () => import("@/components/common/fileView");
const wxFileView = () => import("@/components/common/wxFileView");
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");
const flowStaff = () => import("@/components/common/flowStaff");
import {
  getCurData,
  dateTimeFormat,
  getDictList,
  intervalTime,
  diffMonth,
  isEdit,
  getCurMonth
} from "@/utils/common";
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
export default {
  name: "leaveApply",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      leaveInput: {
        id: "",
        applicantId: "", //申请人id
        applicantName: "", //申请人姓名
        leaveType: "", //请假类型id
        leaveTypeName: "", //请假类型名称
        lactationType: "", //哺乳假类型
        lactationTypeName: "", //哺乳假类型名称
        startTime: "", //请假开始时间
        endTime: "", //请假结束时间
        leaveDays: "", //请假天数数组
        reason: "", //原因
        verifyStatus: "hold", //详情的当前状态
        baseAnnexes: [], //附件
      },
      leaveDay: "", //请假天数
      surplusLeaveDays: "", //剩余请假天数
      holidayType: false, //剩余请假天数显示隐藏
      mode: "add",
      commonId: "", //编辑Id
      editType: false, //当前表单是否可以编辑
      showLeaveTypePicker: false, //请假类型弹框
      showLactationPicker:false,//哺乳假类型弹框
      lactationList:[
        {
          dictCode:'1',
          dictName:'迟一小时上班',
        },
        {
          dictCode:'2',
          dictName:'早一小时下班',
        },
      ],//哺乳假类型数据
      leaveTypeList: [], //请假类型数据
      showTimePicker: false, //时间控件
      showTimePickerOne:false,
      showTimePickerTwo:false,
      currentDate: new Date(), //当前时间
      minDate: new Date(new Date(new Date().toLocaleDateString()).getTime()),
      checkIndex: "", // 获取请假开始和结束时间
      verifyPageType: false, //审批弹框,默认不显示
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      refreshPage: false, // 网络请求失败时显示
      sendType: "", //判断是否在抄送列表
      clientType: getDeviceType(), //手机类型
      is_weixn: is_wei(), //是否为微信
      hour:'08',//选择的是08点的时候
    };
  },
  async mounted() {
    if (is_wei()) {
      document.title = "请假申请";
    }
    let year=new Date().getFullYear();
    let date=year+'/01/01';
    this.minDate=new Date(date);
    this.leaveTypeList = await getDictList("qingjia");
    window.editPage = this.editPage; //编辑页面
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑 verify 审批
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.$nextTick(function () {
      this.editType = this.mode == "add" ? true : false;
      this.setShowLoad(false); //加载状态，默认为true加载

      if (this.userinfo && this.userinfo.id) {
        this.leaveInput.applicantName =
          this.mode == "add" ? this.userinfo.realName : "";
        this.leaveInput.applicantId =
          this.mode == "add" ? this.userinfo.id : "";
      }

      this.mode !== "add" ? (this.commonId ? this.getDetails() : "") : "";
    });
  },
  components: {
    refreshPage,
    fileView,
    wxFileView,
    auditList,
    flowList,
    verifyMain,
    flowStaff,
  },
  methods: {
    timeChange(picker){
      let v=picker.getValues()
      this.hour=v[3];
     
      console.log(v,'timeChange2',this.checkIndex == "1")
    },
    filterOne(type, options) {
      console.log('type, options')
      if (type === "hour") {
        return ['08','14'];
      }
      if (type === "minute") {
        return this.hour == "08"?['30']:['00'];
      }
      return options;
    },
    filterTwo(type, options) {
      if (type === "hour") {
        return ['12','18'];
      }
      if (type === "minute") {
        return ['00'];
      }
      return options;
    },
    ...mapMutations(["setShowLoad"]),
    editPage() {
      //app调用编辑
      let _this = this;
      this.editType = true;
      if (
        _this.leaveInput.leaveType == "qingjia001" ||
        _this.leaveInput.leaveType == "qingjia004" ||
        _this.leaveInput.leaveType == "qingjia005" ||
        _this.leaveInput.leaveType == "qingjia006" ||
        _this.leaveInput.leaveType == "yrj"
      ) {
        _this.holidayType = true;
        _this.getLeaveDay(
          _this.leaveInput.leaveType,
          _this.leaveInput.applicantId,
          _this.leaveInput.workflowCode ? _this.leaveInput.workflowCode : ""
        );
      } else {
        _this.holidayType = false;
      }
    },
    verifyPage() {
      //app调用审批
      this.verifyPageType = true;
    },
    //获取请假天数
    getLeaveDay(type, applicantId, workflowCode) {
      let _this = this;
      _this.$api.administration.administration.leave
        .annualLeave({
          type: type,
          applicantId: applicantId,
          workflowCode: _this.mode == "edit" ? workflowCode : "",
        })
        .then((res) => {
          if (res.code == "1" && res.data) {
            _this.surplusLeaveDays = (
              parseFloat(res.data.totalVacation) -
              parseFloat(res.data.usedVacation ? res.data.usedVacation : 0)
            ).toFixed(1);
            _this.leaveDay = parseFloat(
              res.data.usedVacation ? res.data.usedVacation : 0
            ).toFixed(1); //请假天数

            // if (
            //   res.data.totalVacation &&
            //   parseFloat(res.data.totalVacation) > 0
            // ) {
            //   return;
            // } else {
            //   _this.leaveTypeList.forEach((item, index) => {
            //     if (
            //       item.dictName == "年假" ||
            //       item.dictName == "产假" ||
            //       item.dictName == "育儿假" ||
            //       item.dictName == "婚假" ||
            //       item.dictName == "陪产假"
            //     ) {
            //       _this.leaveType.splice(index, 1);
            //     }
            //   });
            // }
          }
        });
    },
    getCheckLeave() {
      let _this = this;
      if (
        _this.holidayType &&
        Number(_this.leaveInput.leaveDays) > Number(_this.surplusLeaveDays)
      ) {
        _this.$toast("请假天数不能大于剩余假期天数");
      }
    },
    /*获取详情*/
    getDetails() {
      let _this = this;
      _this.$api.administration.administration.leave
        .details(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.leaveInput = newApi.assign({}, _this.leaveInput, res.data);
            _this.lactationList.forEach(item=>{
              if(item.dictCode==_this.leaveInput.lactationType){
                _this.leaveInput.lactationTypeName=item.dictName
              }
            })
            if (
              (_this.leaveInput.verifyStatus == "hold" ||
                _this.leaveInput.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              //  _this.getLeaveDay(res.data.leaveType,res.data.applicantId,res.data.workflowCode)
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          let text = "网络失败，请稍后重试";
          closePage(text);
        });
    },
    //
    showLeavePicker() {
      if (this.editType) {
        this.showLeaveTypePicker = true;
      }
    },
    showLactaPicker() {
      if (this.editType) {
        this.showLactationPicker = true;
      }
    },
    /*获取哺乳假类型数据*/
    savelactationType(data) {
      this.showLactationPicker = false;
      this.leaveInput.lactationTypeName = data.dictName;
      this.leaveInput.lactationType = data.dictCode;
    },
    /*获取请假类型数据*/
    saveLeaveType(data) {
      this.showLeaveTypePicker = false;
      this.leaveInput.leaveTypeName = data.dictName;
      this.leaveInput.leaveType = data.dictCode;
      this.leaveInput.startTime='';
      this.leaveInput.endTime='';
      this.leaveInput.leaveDays='';
      this.leaveInput.lactationType = "";
      this.leaveInput.lactationTypeName = "";
      //监测假期剩余天数是否展示
      if (
        data.dictCode == "qingjia001" ||
        data.dictCode == "qingjia004" ||
        data.dictCode == "qingjia005" ||
        data.dictCode == "qingjia006" ||
        data.dictCode == "yrj"
      ) {
        this.holidayType = true;
        this.getLeaveDay(
          data.dictCode,
          this.leaveInput.applicantId,
          this.leaveInput.workflowCode ? this.leaveInput.workflowCode : ""
        );
      } else {
        this.holidayType = false;
      }
    },
    /*获取时间控件*/
    TimePicker(type) {
      if (this.editType) {
        if(type==2 && this.endTimeDisabled){//结束时间并且婚假，婚假不可拆分休息
          return false;
        }
        this.checkIndex = type;
        // this.showTimePicker = true;
        type==1?this.showTimePickerOne=true:this.showTimePickerTwo=true
      }
    },
    /*获取时间数据*/
    onTimeConfirmOne(data) {
      let h=data.getHours();
      if(h==8){
        data.setMinutes(30);
      }else{
        data.setMinutes(0);
      }
      this.showTimePickerOne = false;
      this.leaveInput.startTime = dateTimeFormat(data);
      if(this.endTimeDisabled ){//婚假并且不能拆分休
        this.getEndTimeByType();//调用接口获取截止日期
      }
    },
    //调用接口获取截止日期,后端返回
    getEndTimeByType() {
      let _this = this;
      _this.$api.administration.administration.leave.getEndTimeByType({ 
        remainingDays:_this.surplusLeaveDays?_this.surplusLeaveDays:_this.userinfo.marriageDay,
        startTime:_this.leaveInput.startTime,
        type: _this.leaveInput.leaveType,
      }).then((res) => {
          if (res.code == "1" && res.data) {
            _this.leaveInput.endTime=res.data;
            // _this.endTime=res.data;
            _this.$set(_this.leaveInput, "leaveDays", _this.surplusLeaveDays?_this.surplusLeaveDays:_this.userinfo.marriageDay);
          }
        });
    },
    onTimeConfirmTwo(data) {
      data.setMinutes(0);
      this.showTimePickerTwo = false;
      this.leaveInput.endTime = dateTimeFormat(data);
    },
    //监测附件方法
    changebaseAnnexes(data) {
      console.log(data,'changebaseAnnexes1111111111')
      this.leaveInput.baseAnnexes = data;
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    /*提交表单*/
    checkInput(msg) {
      let _this = this;
      console.log(_this.leaveInput);
      /*校验*/
      if (
        _this.leaveInput.applicantId &&
        _this.leaveInput.leaveType &&
        _this.leaveInput.leaveDays &&
        _this.leaveInput.reason
      ) {
        if (parseFloat(_this.leaveInput.leaveDays) > 0) {
          if (
            _this.holidayType &&
            Number(_this.leaveInput.leaveDays) > Number(_this.surplusLeaveDays)
          ) {
            _this.$toast("请假天数不能大于剩余假期天数");
          } else if(_this.leaveInput.leaveType=='qingjia003' &&(!_this.leaveInput.baseAnnexes || _this.leaveInput.baseAnnexes.length<=0)){
            _this.$toast("病假必须传附件");
          }else if(_this.leaveInput.leaveType=='qingjia007' &&(!_this.leaveInput.baseAnnexes || _this.leaveInput.baseAnnexes.length<=0)){
            _this.$toast("产前检查假则附件必传");
          }else if(_this.leaveInput.leaveType=='qingjia009' && !_this.leaveInput.lactationType){
            _this.$toast("带星号为必填，不能为空");
          } else {
            _this.mode = msg;
            _this.saveAll();
          }
        } else {
          _this.$toast("请假天数不能小于0");
        }
      } else {
        _this.$toast("带星号为必填，不能为空");
      }
    },
    /*保存接口*/
    saveAll() {
      let _this = this;
      _this.btnLoading = true;
      _this.$api.administration.administration.leave
        .leaSave(_this.mode, _this.leaveInput)
        .then((res) => {
          if (res.code == "1") {
            let text = this.mode == "add" ? "添加成功" : "编辑成功";
            closePage(text);
          } else {
            // console.log(res.msg);
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          console.log(err);
          _this.btnLoading = false;
          _this.$toast("网络失败，请稍后重试");
        });
    },
    /*撤回/删除*/
    delApply() {
      let _this = this;
      let msg = _this.leaveInput.verifyStatus == "hold" ? "删除" : "撤回";
      _this.$dialog
        .confirm({
          title: "确认" + msg,
          message: "您确认要" + msg + "当前申请?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.administration.administration.leave
            .operate(_this.leaveInput.verifyStatus, _this.leaveInput.id)
            .then((res) => {
              if (res.code == "1") {
                let text = msg + "操作成功";
                closePage(text);
              } else {
                _this.$toast(res.msg);
                console.log(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              _this.btnLoading = false;
              _this.$toast("网络失败，请稍后重试");
            });
        });
    },
    // 自动算请假天数
    getLeaveDayTime(){
      let _this = this;
      if(_this.leaveInput.startTime && _this.leaveInput.endTime && _this.leaveInput.leaveType){
        _this.$api.administration.administration.leave.getLeaveDays
      ({startTime:_this.leaveInput.startTime,endTime:_this.leaveInput.endTime,leaveType:_this.leaveInput.leaveType})
        .then((res) => {
          if (res.code == "1") {
            _this.$set(_this.leaveInput, "leaveDays", res.data);
          } else {
            _this.$Message.error(res.msg);
          }
        })
        .catch((err) => {
          _this.$Message.error(err);
        });
      }
      
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
    endTimeDisabled(){//结束日期是否可以选择，婚假并且婚假拆分休息
      return this.leaveInput.leaveType=='qingjia006' && !this.userinfo.isSeparateMarriage
    },
  },
  watch: {
    userinfo: {
      handler: function () {
        if (this.userinfo && this.userinfo.id) {
          this.leaveInput.applicantName =
            this.mode == "add" ? this.userinfo.realName : "";
          this.leaveInput.applicantId =
            this.mode == "add" ? this.userinfo.id : "";
        }
      },
      deep: true,
    },
    'leaveInput.startTime'(){
      if(!this.endTimeDisabled ){
        this.getLeaveDayTime();
      }
    },
    'leaveInput.endTime'(){
      if(!this.endTimeDisabled ){
        this.getLeaveDayTime();
      }
    },
    'leaveInput.leaveType'(){
      this.getLeaveDayTime();
    }
  },
};
</script>
<style lang="less">
.leavePage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  padding-top: 12px;

  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.endTimeDisabled {
    .van-field__body {
      .van-field__control {
        color: #ccc;
      }
    }
  }
  .endTimeDisabled{
    .van-icon {
      color: #ccc;
    }
  }
  .baseNone.moreText {
    .van-cell {
      .van-cell__title {
        width: 160px;
      }
    }
  }
  .baseNone.moreLeaveText {
    .van-cell {
      .van-cell__title {
        width: 200px;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }

  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
  //审批操作样式
}
</style>